





























import Vue from "vue";
// @ts-ignore
import VueScrollReveal from "vue-scroll-reveal";
Vue.use(VueScrollReveal, {
  class: "v-scroll-reveal", // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 1000,
  scale: 1.35,
  distance: "10px",
  mobile: true,
});

export default Vue.extend({
  name: "Sponsors",
  props: {
    sponsorList: Array,
    main: Boolean,
    secondary: Boolean,
  },
  methods: {
    shuffle: function shuffle(a: any) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
  },
  computed: {
    getClass() {
      if (this.main) {
        return "level--1";
      } else if (this.secondary) {
        return "level--2";
      }
    },
  },

  mounted() {
    const VanillaTilt = require("vanilla-tilt");
  },
});
